import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
import { runtime } from '../../../../classes/runtime/Runtime';
export class ConditionRegistryTime extends ConditionRegistryCategory {
    label = 'Zeit';
    constructor(parent) {
        super(parent);
        super.init();
    }
    delay = () => new ConditionRegistryItem({
        eval: ({ evaluator, rightChildEvaluator }) => {
            const isTrueNow = rightChildEvaluator && rightChildEvaluator.isConditionTrue;
            setTimeout(() => runtime.runtimeScheduler.scheduleForAnimationFrame(() => evaluator.entityTemp.flexMap.set('delay', isTrueNow)), evaluator.valueOf.timespanInMilliseconds);
            return !!evaluator.entityTemp.flexMap.get('delay');
        },
        /*    label: 'Verzögere um',
        params: { core: ['timespanInMilliseconds'] } */
    });
    blink = () => new ConditionRegistryItem({
        eval: ({ app, evaluator }) => {
            return (app.appClock.clock_100.tickingTime % evaluator.valueOf.timespanInMilliseconds <
                evaluator.valueOf.timespanInMilliseconds / 2);
        },
        /*  label: 'Blikend um',
        params: { core: ['timespanInMilliseconds'] } */
    });
}
